





































import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import LiquorTree from 'liquor-tree';
import { WorkflowTreeModel } from '@/types';
import { WorkflowTreeService } from '@/services/WorkflowTreeService';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { TreeViewHeader } from '@/components/shared';
import { TreeViewHelpers } from '@/mixins/treeView';
import { MStoreConstants, WorkflowTreeConstants } from '@/types/constants';
import { LocalStorage } from '@/utils';
Vue.use(LiquorTree);

export default Vue.extend({
  name: 'WorkflowTreeView',
  mixins: [TreeViewHelpers],
  props: {
    loading: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      data: {} as WorkflowTreeModel[],
      options: {
        checkbox: false,
        parentSelect: true
      }
    };
  },
  computed: {
    ...mapGetters('workflowQueueStore', ['getLastSelectedWorkflowQueue']),
    ...mapGetters('userPreferencesStore', ['getSelectedWorkflowQueue']),
    _isLoading: {
      get(this: any) {
        return this.loading;
      },
      set(this: any, value: boolean) {
        this.$emit('update:loading', value);
      }
    },
    lastSelectedQueueId(this: any) {
      return this.getLastSelectedWorkflowQueue;
    },
    lastSelectedQueueIdOnOtherTab(this: any) {
      return this.getSelectedWorkflowQueue();
    }
  },
  methods: {
    ...mapActions('workflowQueueStore', ['setLastSelectedWorkflowQueue']),
    ...mapActions('userPreferencesStore', ['setSelectedWorkFlowQueueId']),
    async getDataAsync() {
      this._isLoading = true;
      this.data = await WorkflowTreeService.getWorkflowTreeAsync();
      const lastSelectedQueue = this.lastSelectedQueueId || this.lastSelectedQueueIdOnOtherTab;
      if (lastSelectedQueue && !this.$route.params.id) {
        await this.$router.push({
          name: 'WorkflowQueue',
          params: {
            id: lastSelectedQueue
          }
        });
      }
      const isValidWorkflowQueue = this.isValidWorkflowQueue(this.data);
      if (isValidWorkflowQueue && this.$route.params.id !== lastSelectedQueue?.toString()) {
        this.setSelectedWorkFlowQueue(this.$route.params.id);
      }
      this._isLoading = false;
    },
    isValidWorkflowQueue(tree: any) {
      return tree?.some((parent: any) => (parent?.children?.length > 0 ? this.isValidWorkflowQueue(parent.children) : parent.data.id === Number(this.$route.params.id)));
    },
    setSelectedWorkFlowQueue(id: any) {
      this.setLastSelectedWorkflowQueue(Number(id));
      this.setSelectedWorkFlowQueueId(id);
      LocalStorage.emit(MStoreConstants.LocalStorageKeys.LastSelectedWorkflowQueue, id);
    },
    onTreeClicked(node: any) {
      if (node.states.selectable && this.$router.currentRoute.params.id !== node.data.id) {
        this.setSelectedWorkFlowQueue(node.data.id);
        this.$router.push({
          name: 'WorkflowQueue',
          params: {
            id: node.data.id
          }
        });
      } else {
        node.states.expanded = !node.states.expanded;
      }
    },
    onTreeMounted(this: any) {
      const id: number = Number(this.$route.params.id);
      if (!id) {
        return;
      }
      const node = this.$refs.tree.find(
        (n: WorkflowTreeModel) => n.data.id === id && (n.data.type === this.WORKFLOW_TREE_NODE_TYPES.JobList || n.data.type === this.WORKFLOW_TREE_NODE_TYPES.FilteredView)
      );
      if (!node) {
        return;
      }
      this.selectNode(node);
    }
  },
  async mounted(this: any) {
    this.WORKFLOW_TREE_NODE_TYPES = WorkflowTreeConstants.WorkflowTreeNodeTypes;
    await this.getDataAsync();
  },
  watch: {
    '$route.params.id'(this: any, id) {
      if (!id) {
        const selectedNode = this.$refs.tree.find({
          state: { selected: true }
        });
        this.unselectNode(selectedNode);
      }
    }
  },
  components: {
    LoadingSpinner,
    TreeViewHeader
  }
});
